import { styled, alpha } from '@mui/material/styles'
import { InputBase, IconButton } from '@mui/material'
import { colorPalette } from '../../style/colorPalette'

// ページ中央に配置するチャットカラム。読みやすさのため幅を抑える。
export const ChatColumn = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: 840,
  height: '100%',
  margin: '0 auto',
  padding: 16,
})

export const ChatCard = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: 0,
  backgroundColor: colorPalette.monotone[0],
  borderRadius: 12,
  border: `1px solid ${colorPalette.monotone[2]}`,
  overflow: 'hidden',
})

export const ChatHeader = styled('div')({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  borderBottom: `1px solid ${colorPalette.monotone[2]}`,
  backgroundColor: colorPalette.monotone[1],
})

export const HeaderTexts = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
})

export const InputArea = styled('div')({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  gap: 8,
  padding: 12,
  borderTop: `1px solid ${colorPalette.monotone[2]}`,
})

export const ChatInput = styled(InputBase)({
  flexGrow: 1,
  backgroundColor: colorPalette.monotone[0],
  borderRadius: 4,
  padding: '8px 12px',
  border: `1px solid ${colorPalette.monotone[2]}`,
  fontSize: 14,
  '&:hover': {
    borderColor: colorPalette.monotone[4],
  },
  '&.Mui-focused': {
    borderColor: colorPalette.skyBlue[7],
    boxShadow: `0 0 0 2px ${alpha(colorPalette.skyBlue[7], 0.2)}`,
  },
})

export const SendButton = styled(IconButton)({
  color: colorPalette.skyBlue[7],
  '&.Mui-disabled': {
    color: colorPalette.monotone[3],
  },
})

export const HeaderIconButton = styled(IconButton)({
  color: colorPalette.monotone[4],
  '&:hover': {
    color: colorPalette.monotone[6],
  },
  '&.Mui-disabled': {
    color: colorPalette.monotone[3],
  },
})

export const InlineError = styled('div')({
  flexShrink: 0,
  padding: '4px 16px',
  color: colorPalette.pink[7],
  fontSize: 12,
})

// 送信前の画像添付プレビュー一覧。
export const AttachmentsPreviewRow = styled('div')({
  display: 'flex',
  flexShrink: 0,
  flexWrap: 'wrap',
  gap: 8,
  // 下側の余白を省くとサムネイルが入力エリアの境界線に接してしまう。
  padding: 12,
})

export const AttachmentPreviewItem = styled('div', {
  shouldForwardProp: prop => prop !== 'hasError',
})<{ hasError?: boolean }>(({ hasError }) => ({
  position: 'relative',
  width: 56,
  height: 56,
  borderRadius: 6,
  overflow: 'hidden',
  border: `1px solid ${hasError ? colorPalette.pink[5] : colorPalette.monotone[2]}`,
}))

export const AttachmentThumb = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
})

export const AttachmentUploadingOverlay = styled('div')({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: alpha(colorPalette.monotone[10], 0.35),
  '&::after': {
    content: '""',
    width: 16,
    height: 16,
    border: `2px solid ${colorPalette.monotone[0]}`,
    borderTop: `2px solid ${colorPalette.skyBlue[7]}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
})

export const RemoveAttachmentButton = styled(IconButton)({
  position: 'absolute',
  top: 0,
  right: 0,
  width: 18,
  height: 18,
  padding: 0,
  color: colorPalette.monotone[0],
  backgroundColor: alpha(colorPalette.monotone[10], 0.5),
  '&:hover': {
    backgroundColor: alpha(colorPalette.monotone[10], 0.7),
  },
})
